module.exports = __webpack_public_path__ + "static/media/belisa_plumilla.4fdac8f1.ttf";